<div class="root" [ngClass]="{'show': show, 'mobile': isMobile}" mouseleave="onLeave()"
     mouseenter="onHover()">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" id="{{elementIndex}}">
        <polygon points="10,0 0,20 20,20" fill="white"/>
    </svg>
    
    <div class="oneClickPurchase">
        <div class="card-info-oneClick">
            <div class="card-info">
                <img src="../../../../assets/images/payment-methods/{{oneClickPurchaseInfo?.brand.toLowerCase()}}.png" alt="Card brand logo">
                <p>{{oneClickPurchaseInfo?.cardNumber}}</p>
                <p>(Crédito a vista)</p>
            </div>
            
        </div>
        <button (click)="purchase()" class="one-click-purchase-btn">
            Pagar com 1 clique
        </button>
        <p class="changeCard-text">
            <a (click)="changePayment()" class="change-card-link">Alterar cartão</a>
        </p>
    </div>
</div>